import NotificationManager from 'common/notifications/NotificationManager';
import { isEmpty } from 'lodash/lang';
import { onRequestError } from 'services/handlers';

import handleExceptions from 'components/pages/patient-source/Patients/PatientInfo/PatientInfoMainSection/AddOrEditPatientInfoModal/services/handleExceptions';

import { PatientInfoApi } from '../../../../../../../../api';

import { validateEditPatientInfo } from './validationService/validationService';
import prepareUpdatePatientInfo from './prepareUpdatePatientInfo';
import showDuplicateEmailModal from './showDuplicateEmailModal';

export default async function initiateEditPatient({
  info,
  currentStudy,
  patientInfo,
  setValidationMessages,
  setLoading,
  postSave,
  onDuplicate,
  modalBox,
  originalPID,
  patientStipendFieldsRequired,
  existingSsn
}) {
  try {
    await validateEditPatientInfo(info, originalPID, patientStipendFieldsRequired, existingSsn);

    const patientInfoRequest = prepareUpdatePatientInfo(info, originalPID);

    setLoading(true);

    if (currentStudy) {
      // if on patient studies page, use new edit check
      PatientInfoApi.updatePatientInfoWithSsu(patientInfo.id, patientInfoRequest, currentStudy.studyId)
        .then(function({
          data: { pidMessage, warningMessage, emailDuplicationMessage, duplicateInfo, existsInStudy, patientInfo }
        }) {
          if (emailDuplicationMessage) {
            showDuplicateEmailModal(emailDuplicationMessage);
            setLoading(false);
          } else if (!isEmpty(duplicateInfo)) {
            modalBox.close();
            onDuplicate(currentStudy, duplicateInfo, existsInStudy, {
              ...patientInfoRequest,
              id: patientInfo.id
            });
          } else {
            postSave();
            if (pidMessage !== '') {
              warningMessage ? NotificationManager.error(pidMessage) : NotificationManager.success(pidMessage);
            } else if (warningMessage) {
              NotificationManager.warning(warningMessage);
            }
          }
        })
        .catch(function(err, params) {
          onRequestError(err, params);
          setLoading(false);
        });
    } else {
      // if not, then we have no source, so cannot do an edit check the same way
      PatientInfoApi.updatePatientInfo(patientInfo.id, patientInfoRequest)
        .then(function({ data: { pidMessage, warningMessage, emailDuplicationMessage } }) {
          if (emailDuplicationMessage) {
            showDuplicateEmailModal(emailDuplicationMessage);
            setLoading(false);
          } else {
            postSave();
          }
          if (pidMessage !== '') {
            warningMessage ? NotificationManager.error(pidMessage) : NotificationManager.success(pidMessage);
          } else if (warningMessage) {
            NotificationManager.warning(warningMessage);
          }
        })
        .catch(function(err, params) {
          onRequestError(err, params);
          setLoading(false);
        });
    }
  } catch (e) {
    handleExceptions(e, info, setValidationMessages);
  }
}
